import { jobSchema } from './general.schema.js'

export const patchJobSchema = jobSchema.pick(['autoRenew']).allFieldsOptional()
export const patchJobGroupSchema = jobSchema.omitNested(['id', 'groupId', 'status', 'jobsBoardType']).allFieldsOptional()

export const patchJobSchemas = { back: patchJobSchema, front: patchJobSchema }
export const patchJobGroupSchemas = { back: patchJobGroupSchema }
